// Others
import axiosClient from './axiosClient';
import { urlApiInvoice } from '~/utils/constants/apis';
import { IBaseResponse, IListDataResponse } from '~/utils/interface/base';
import {
  IChangeStatusInvoiceBody,
  IInvoice,
  IInvoiceDetail,
  IQueryCreateInvoice,
  IQueryGetInvoiceDetails,
  IQueryParamInvoice,
  IResInvoiceCreated,
  ISendInvoiceBody,
} from '~/utils/interface/invoice';

const invoiceApi = {
  getInvoiceList(params: IQueryParamInvoice) {
    const url = urlApiInvoice.getInvoiceList;
    return axiosClient.get<IBaseResponse<IListDataResponse<IInvoice[]>>>(url, { params });
  },

  createInvoice(body: IQueryCreateInvoice) {
    const url = urlApiInvoice.getInvoiceList;
    return axiosClient.post<IBaseResponse<IResInvoiceCreated>>(url, body);
  },

  getInvoiceDetails({ invoiceId, params }: IQueryGetInvoiceDetails) {
    const url = urlApiInvoice.getInvoiceDetails(invoiceId);
    return axiosClient.get<IBaseResponse<IInvoiceDetail>>(url, { params });
  },

  changeStatus({ invoiceId, body }: IChangeStatusInvoiceBody) {
    const url = urlApiInvoice.changeStatusInvoice(invoiceId);
    return axiosClient.put<IBaseResponse>(url, body);
  },

  sendInvoice({ invoiceId, body }: ISendInvoiceBody) {
    const url = urlApiInvoice.sendInvoice(invoiceId);
    return axiosClient.post<IBaseResponse>(url, body);
  },
};

export default invoiceApi;
